import { Close as PopoverClose } from '@radix-ui/react-popover';
import { PropsWithChildren } from 'react';

export const Close = ({ children }: PropsWithChildren) => <PopoverClose asChild>{children}</PopoverClose>;
